import React from 'react';

import { configs } from '$configs';
import { SORT, COLORS, DATE_FORMATS } from '$gbusiness/enums';
import CellModel from '$gbusiness/models/cell';
import { COLOR, Div } from '$gstyles';
import { Chip, Button } from '@material-ui/core';
import MoreHorizIcon from '@material-ui/icons/MoreHoriz';
import { deriveRawToInvoice } from '$business/models/invoice';
import intl from '$intl';
import PopOver from '$gcomponents/reusables/popOver';
import { KEYS as EMAIL_STATUS } from '$business/enums/options/emailStatus';
import { KEYS as BILL_TYPE } from '$business/enums/options/billType';
import { format } from '$ghelpers/date';

import { ROUTES } from '$business/enums';

export const TABLE_CONFIG = {
  endpoint: configs.api.invoice.list,
  deriveToModel: deriveRawToInvoice,
  color: COLORS.SECONDARY,
  pageSize: 50,
  fontSize: '0.9em',
  cellPadding: `3px`,
  isStripped: true,
  minWidth: 960,
  maxWidth: 1300,
  defaultSortKey: 'createdAt',
  defaultSortOrder: SORT.DSC,
  shouldVirtualize: false,
  virtualized: {
    rowHeight: 36,
    headerHeight: 60,
    checkWidth: 60,
    threshold: 10,
    additionalHeight: 40,
  },
  filter: {
    color: COLORS.PRIMARY,
  },
};

export const TABLE: Array<CellModel> = [
  {
    label: 'SCREEN.INVOICE.COLS.BILL_DATE',
    value: 'billDate',
    // component: row => <>{row.createdAt ? format(row.createdAt.substr(0, 10), DATE_FORMATS.SLASH) : ''}</>,
    sortable: SORT.ASC,
    width: 180,
  },
  {
    label: 'SCREEN.INVOICE.COLS.IMPORTED_DATE',
    value: 'importedDate',
    component: row => <>{row.importedDate ? format(row.importedDate, DATE_FORMATS.SLASH) : ''}</>,
    width: 180,
  },
  {
    label: 'SCREEN.INVOICE.COLS.SEQ',
    value: 'invoiceId',
    sortable: SORT.ASC,
    sortKey: 'id',
    width: 80,
  },
  {
    label: 'SCREEN.INVOICE.COLS.PAST_DUE',
    value: 'pastDue',
    component: row => {
      const color = row.pastDue === 'YES' ? COLOR.DANGER : COLOR.SUCCESS;
      return (
        <Div color={color} fontWeight="600">
          {row.pastDue}
        </Div>
      );
    },
    width: 150,
  },
  {
    label: 'SCREEN.INVOICE.COLS.BILL_TYPE',
    value: 'invoiceType',
    component: row => {
      const color =
        row.invoiceType === BILL_TYPE.CONTRACT
          ? 'primary'
          : row.invoiceType === BILL_TYPE.PPI
          ? 'tertiary'
          : row.invoiceType === BILL_TYPE.SALES
          ? 'SALES'
          : 'default';
      return (
        <Chip
          variant="outlined"
          className={`${color} outlined`}
          size="small"
          label={intl('INPUT.OPTION.BILLING_TYPE.' + row.invoiceType)}
        />
      );
    },
    sortable: SORT.ASC,
    width: 200,
  },
  {
    label: 'SCREEN.INVOICE.COLS.BILL_NUMBER',
    value: 'billNo',
    sortable: SORT.ASC,
    width: 240,
  },
  {
    label: 'SCREEN.INVOICE.COLS.CUSTOMER_CODE',
    value: 'customerCode',
    sortable: SORT.ASC,
    width: 200,
  },
  {
    label: 'SCREEN.INVOICE.COLS.EMAIL',
    value: 'email',
    sortable: SORT.ASC,
    width: 350,
  },
  {
    label: 'SCREEN.INVOICE.COLS.STATUS',
    value: '',
    component: row => {
      const color =
        row.emailStatus === EMAIL_STATUS.FAILED
          ? 'danger'
          : row.emailStatus === EMAIL_STATUS.SUCCESS
          ? 'success'
          : 'default';
      const key = 'STATUS.EMAIL.' + (row.emailStatus || 'DEFAULT');
      return (
        <Div className={`outlined ${color}`} fontWeight="600">
          {intl(key)}
        </Div>
      );
    },
    width: 200,
  },
  {
    label: 'SCREEN.INVOICE.COLS.ACTION',
    value: '',
    align: 'center',
    className: 'action',
    component: (row, actions) => {
      return (
        <PopOver component={<MoreHorizIcon className="pointer" />}>
          <>
            <Button className="left" fullWidth onClick={() => actions.viewDetails(row)}>
              {intl('SCREEN.INVOICE.ACTIONS.VIEW_DETAILS')}
            </Button>
            <Button className="left" fullWidth onClick={() => actions.updateStatus(row)}>
              {intl('SCREEN.INVOICE.ACTIONS.UPDATE_STATUS')}
            </Button>
            <Button
              className="left"
              fullWidth
              onClick={() => {
                window.open(`${ROUTES.PAYMENT}/${row.uuid}`, '_blank');
              }}>
              {intl('SCREEN.INVOICE.ACTIONS.PAY_LINK')}
            </Button>
          </>
        </PopOver>
      );
    },
    width: 100,
  },
];
